import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForEmployeeImageReportSundry } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { EmployeeImageReportSundrySchemaObject } from "../EmployeeImageReportSundrySchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import MessageModal from "../../../../UI/Modal/MessageModal";

const screenCode = "EMPLOYEEIMAGEREPORTSUNDRY";

export function EmployeeImageReportSundry(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [multipleEstates, setMultipleEstates] = useState([]);

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        date: new Date().toISOString().split('T')[0],
        narration: "0",

    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        collectionType: "0",
        date: new Date().toISOString().split('T')[0],
        narration: "0",

    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(EmployeeImageReportSundrySchemaObject).options({ allowUnknown: true });
    const [contentRowNames, setContentRowNames] = useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropDown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown()
        )
    }, [leafCollectionDetails.estateID])

    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.estateID]);

    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.divisionID]);

    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.groupID]);

    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.date]);
    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.narration]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            narration: "0"
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }
    function handleEstateChange(target) {
        validateInputs(target);
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            estateID: target.value,
            divisionID: "0",
            narration: "0",
            date: new Date().toISOString().split('T')[0]
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            divisionID: target.value,
            narration: "0",
            date: new Date().toISOString().split('T')[0],
        });
    }
    function handleNarrationChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, EmployeeImageReportSundrySchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            [e.target.name]: value
        })
    }
    function handleDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            date: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, EmployeeImageReportSundrySchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEEIMAGEREPORTSUNDRY');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setLeafCollectionDetails({
                ...leafCollectionDetails,
                groupID: token.groupID,
                date: new Date().toISOString().split('T')[0],
            });
        }
        else {
            setLeafCollectionDetails({
                ...leafCollectionDetails,
                groupID: token.groupID,
                estateID: token.operationEntityID,
                date: new Date().toISOString().split('T')[0],
            });
        }
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID,
            date: new Date().toISOString().split('T')[0],
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropDown() {
        const data = await services.getEstatesByGroupID(leafCollectionDetails.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() { 
        const data = await services.getCollectionPointByOperationEntityId(leafCollectionDetails.groupID,leafCollectionDetails.estateID);
        setDivisions(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);
        destroyDataTable();

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getEmployeeImageReportSundryData(leafCollectionDetails);
        if (result.length == 0) {
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        if (result.length > 0) {
            var headers = [];
            var allHeaders = [];
            var tableData = [];
            var contentHeaders = [];

            result.forEach(x => {
                allHeaders.push(x.sessionName);
            });

            allHeaders = allHeaders.sort();
            headers.push("Registration Number");
            headers.push("Name");
            headers.push("Biometric Image");
            headers.push("Job Code");
            headers.push("Job Type");
            headers.push("Capture Image");
            contentHeaders.push("employeeCode");
            contentHeaders.push("fullName");
            contentHeaders.push("convertedEmployeeBiometricData");
            contentHeaders.push("taskCode");
            contentHeaders.push("jobType");
            contentHeaders.push("employeeSessionImageData");


            result.forEach(x => {

                if (tableData.length == 0) {
                    var firstRecord = {
                        convertedEmployeeBiometricData: "data:image/jpg;base64," + x.employeeSessionImageData,
                        taskCode: x.taskCode,
                        jobType: x.jobType == 1 ? "General" : x.jobType == 2 ? "Cash" : "OT",
                        employeeCode: x.employeeCode,
                        fullName: x.fullName,
                        employeeID: x.employeeID,
                        employeeSessionImageData: "data:image/jpg;base64," + x.employeeSessionImageData,
                    };
                    tableData.push(firstRecord);
                }
                else {

                    var record = {
                        [x.sessionName]: "data:image/jpg;base64," + x.employeeSessionImageData,
                        employeeSessionImageData: "data:image/jpg;base64," + x.employeeSessionImageData,
                        convertedEmployeeBiometricData: x.convertedEmployeeBiometricData,
                        taskCode: x.taskCode,
                        jobType: x.jobType,
                        jobType: x.jobType == 1 ? "General" : x.jobType == 2 ? "Cash" : "OT",
                        employeeCode: x.employeeCode,
                        fullName: x.fullName,
                        employeeID: x.employeeID
                    };

                    tableData.push(record);

                }
            });

            if (tableData.length > 0) {
                setIsTableHide(false);
                setTableHeaders(headers);
                setContentRowNames(contentHeaders);
                setReportData(tableData);
                createDataTable();
            }
        }
    }

    function createDataTable() {
        $('#sessionImageTable').DataTable();
    }

    function destroyDataTable() {
        $('#sessionImageTable').DataTable().destroy();
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            divisionID: "0",
            toDate: "",
            fromDate: "",
            date: new Date().toISOString().split('T')[0],
            narration: "0"
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            date: searchForm.date,
            narration: leafCollectionDetails.narration,

        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Employee Image Report Sundry"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Operation entity * </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={leafCollectionDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="divisionID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={leafCollectionDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md">
                                        <TextField select fullWidth
                                            label="Job Type "
                                            id="narration"
                                            name="narration"
                                            value={leafCollectionDetails.narration}
                                            type="text"
                                            onChange={(e) => handleNarrationChange(e)}>
                                            <option value="0">--Select Job Type--</option>
                                            <option value="1">General</option>
                                            <option value="2">Cash</option>
                                            <option value="3">OT</option>

                                        </TextField>
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            value={leafCollectionDetails.date}
                                            type="date"
                                            onChange={(e) => handleDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="button"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row pt-3 pb-3">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="sessionImageTable" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            {
                                                                tableHeaders.map((x, index) => {
                                                                    return (
                                                                        <th
                                                                            key={index}
                                                                            style={{
                                                                                textAlign: (x === "Name" || x === "Registration Number" || x === "taskCode" || x === "jobType") ? "left" : "center",
                                                                                width: index < 2 ? "180px" : "auto"
                                                                            }}
                                                                        >
                                                                            {x}
                                                                        </th>
                                                                    );
                                                                })
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForEmployeeImageReportSundry
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <ReactToPrint
                                            documentTitle={"Employee Image Report Sundry"}
                                            trigger={() => (
                                                <input
                                                    type="submit"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="PDF"
                                                />
                                            )}
                                            content={() => componentRef.current}
                                        />
                                    </div>

                                    <div hidden={true}>
                                        <CreatePdf
                                            ref={componentRef}
                                            data={reportData}
                                            tableHeaders={tableHeaders}
                                            rowNames={contentRowNames}
                                            searchData={selectedSearchValues}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}
